import React from "react";
import { HashRouter, Routes, Route } from "react-router-dom";

import "./App.css";
import SwordfishTrombone from "./swordfishtrombone";
import ApprovalPage from "./components/ApprovalPage";

import Layout from "./components/Layout";
import ArtistsPage from "./pages/ArtistsPage";
import ArtistPage from "./pages/ArtistPage";
import SongsPage from "./pages/SongsPage";
import SongPage from "./pages/SongPage";
import NewsPage from "./pages/NewsPage"



export default function App() {
  const path = window.location.pathname;

  // Keep your existing special approval URL behavior
  if (
    path === "/approve-buboes1is2Verynice3456" ||
    path === "/swordfishtrombone/approve-buboes1is2Verynice3456"
  ) {
    return <ApprovalPage />;
  }

  return (
    <div className="App">
      <HashRouter>
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<SwordfishTrombone />} />
            <Route path="/artists" element={<ArtistsPage />} />
            <Route path="/artists/:artistSlug" element={<ArtistPage />} />
            <Route path="/songs" element={<SongsPage />} />
            <Route path="/songs/:songSlug" element={<SongPage />} />
            <Route path="/news" element={<NewsPage />} />
          </Route>
        </Routes>
      </HashRouter>
    </div>
  );
}
